// Refresh the signed URLs once they're within this long of expiring.
const URL_REFRESH_MARGIN_MS = 30 * 60 * 1000;

/**
 * Which manifest to play after a poll. Every response carries freshly signed
 * URLs, and a new URL means the TV downloads every screenshot again. So keep
 * the current one unless the screenshots changed or its URLs are about to
 * expire.
 */
const pickManifest = ({
  current,
  next,
  now,
}: {
  current: WallboardScreenshots.ManifestResponse | undefined;
  next: WallboardScreenshots.ManifestResponse;
  now: number;
}): WallboardScreenshots.ManifestResponse => {
  if (!current || current.generationId !== next.generationId) {
    return next;
  }
  const expiresAt = Date.parse(current.urlsExpireAt);
  if (Number.isNaN(expiresAt) || expiresAt - now < URL_REFRESH_MARGIN_MS) {
    return next;
  }
  return current;
};

export default pickManifest;
